import { SalesChecklistOrgEditor } from "@/components/location-tools/SalesChecklistOrgEditor";
import { WorkplaceCommsOversightPanel } from "@/components/ops/WorkplaceCommsOversightPanel";
import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";

/**
 * Ops bucket authoring surface for the Leads daily operating checklist
 * (turbo_ops.md §5.8). Sales reps consume the template via
 * `SalesDailyChecklistWidget`; Ops owns questions, scoring, and escalation.
 */
export function OpsDailyChecklistPanel() {
  const organizationId = useScopedOrganizationId();

  if (!organizationId) {
    return (
      <div className="w-full text-left space-y-3">
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Daily checklist</h2>
        <p className="text-sm text-gray-500 dark:text-zinc-400">Select a workspace organization first.</p>
      </div>
    );
  }

  return (
    <div className="w-full text-left space-y-4">
      <div>
        <h2 className="text-lg font-bold text-gray-900 dark:text-zinc-100">Daily operating checklist</h2>
        <p className="text-sm text-gray-600 dark:text-zinc-300 mt-1 max-w-3xl">
          Author the template Sales reps see on the Leads tab and Activity dock: manual tasks and schedules,
          ad-logging scoring, stale-lead escalation, acknowledgement blocking, and org-wide manager nudges.
          Config is stored in Ops settings and overrides any legacy Location Tools copy.
        </p>
      </div>
      <WorkplaceCommsOversightPanel organizationId={organizationId} />
      <SalesChecklistOrgEditor organizationId={organizationId} variant="ops" />
    </div>
  );
}
